import React, { useEffect } from "react";

const LogModal = (props) => {
  useEffect(() => {
    let Items = [];
    props.LogData.map((Item, i) => {
      let Error = "";
      if (Item.status === "STOPPED") {
        Error = "ERROR: " + '"' + Item.messages + '"';
      }
      let ItemToPush =
        Item.state + " " + props.StageName + switchStatus(Item.status) + Error;
      Items.push(ItemToPush.toLowerCase());
    });
    document.getElementById("logs-to-copy").value = Items.toString();
  }, []);
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const replaceText = (LogItem, i) => {
    let StageName;
    if (i % 2 === 0) {
      StageName = " Base ";
    } else {
      StageName = " Staging ";
    }
    return (
      LogItem.state +
      " " +
      StageName +
      switchStatus(LogItem.status)
    ).toLowerCase();
  };

  const copyLogs = () => {
    document.getElementById("logs-to-copy").select();
    document.execCommand("copy");
  };

  const switchStatus = (Status) => {
    switch (Status) {
      case "IN_PROGRESS":
        return "Done";
      case "COMPLETED":
        return "Done";
      case "STOPPED":
        return "Failed";
    }
  };

  return (
    <div className="screen-overlay">
      <textarea id="logs-to-copy" />
      <div className="overlay-body logs-body">
        <section className="overlay-head">
          <h1>{translateText("logs")}</h1>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="details">
          <section className="detail-label"></section>
          <div className="detail-body">
            {props.LogData.map((LogItem, i) => (
              <React.Fragment>
                {LogItem.state.length === 0 ||
                LogItem.state.length === 0 ? null : (
                  <React.Fragment>
                    {LogItem.status === "IN_PROGRESS" ? null : (
                      <div className="detail-row" key={LogItem.id}>
                        <p className="csv-name">{replaceText(LogItem, i)}</p>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            ))}
          </div>
        </section>
        <button className="copy-btn" onClick={() => copyLogs()}>
          {translateText("copy")}
        </button>
      </div>
    </div>
  );
};

export default LogModal;
